'use client';
import React, { Component } from 'react';

import MainTitle from '../reusable-components/layouts-components__common-cases/main-title';
import NextProject from '../reusable-components/layouts-components__common-cases/next-project';
import FullWrapper from '../reusable-components/layouts-components__common-cases/full-wrapper';
import { getAdjacentCase } from '../../../../../shared/utilities/GetAdjacentCase/getAdjacentCase';

import './style.sass';
import '../reusable-components/style.sass';

import Tasks from '../reusable-components/layouts-components__dev-rec/tasks';
import Complex from '../reusable-components/layouts-components__dev-rec/complex';
import Process from '../reusable-components/layouts-components__dev-rec/process';
import Services from '../reusable-components/layouts-components__dev-rec/services';
import Portal from '../reusable-components/layouts-components__dev-rec/portal';
import Results from '../reusable-components/layouts-components__dev-rec/results';
import Numbers from '../reusable-components/layouts-components__dev-rec/numbers';
import Team from '../reusable-components/layouts-components__dev-rec/team';
import ScrollAnimation from '../../../../../core/ScrollAnimation';
import OfferButton from '../../../../../shared/sections/OfferButton';

const devRecMainTitle = {
    titleMainText: `Поддержка и&nbsp;модернизация сайта и&nbsp;внутреннего портала Группы РЭЦ`,
    titleAnimation: '/images/png/dev-rec.png',
    center: true,
    subtitleContainer: [
        {
            modeText: 'клиент',
            colorMode: '#3a74b7',
            nameText: 'Группа РЭЦ',
        },
        {
            modeText: 'Услуги',
            colorMode: '#3a74b7',
            nameText: 'техническая поддержка, разработка',
        },
        {
            modeText: 'Технологии',
            colorMode: '#3a74b7',
            nameText:
                'PHP, Bitrix, MySQL, npm, webpack, Sass, TypeScript, Docker, Composer, Git, SOAP',
        },
        {
            modeText: '',
            colorMode: '#3a74b7',
            nameText:
                '<br> Группа РЭЦ занимается поддержкой несырьевого экспорта, предоставляет российским компаниям широкий спектр финансовых и&nbsp;нефинансовых мер поддержки.',
        },
    ],
};

class DevRec extends Component {
    render() {
        const casePathname = '/cases/development/dev-rec';
        const adjacentCase = getAdjacentCase(casePathname);

        return (
            <section className="dev-rec">
                <div className="dev-rec__title-wrap">
                    <MainTitle MainTitle={devRecMainTitle}></MainTitle>
                </div>

                <Tasks />

                <Complex />

                <Process />

                <Services />

                <Portal />

                <Results />

                <Numbers />

                <Team />

                <ScrollAnimation animateIn="zoomIn" offset={50} animateOnce={true} duration={1}>
                    <FullWrapper>
                        <OfferButton linkText="Нанять команду" />
                    </FullWrapper>
                </ScrollAnimation>

                {adjacentCase && (
                    <NextProject
                        NextProject={{
                            nextProjectTitle: adjacentCase.case.title,
                            nextProjectImg: adjacentCase.case.image,
                            nextProjectLink: adjacentCase.case.router,
                            nextProjectText: adjacentCase.case.description,
                            nextProjectLabel: adjacentCase.label,
                        }}
                    />
                )}
            </section>
        );
    }
}

export default DevRec;
